module.exports = __webpack_public_path__ + "static/media/login-bg-3.950b1857.jpg";